import { useApi } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { ProviderType } from '../types';

export type CoachPublicInfo = {
  bio: string;
  display_name: string;
  first_name: string;
  full_name: string;
  healthie_id: number;
  image_url: string;
  last_name: string;
  schedule_link: string;
  title: string;
  type: ProviderType.Coach;
};

export const useCoachPublicInfo = (coachId: string | undefined) => {
  const { api } = useApi();

  const fetchPublicInfo = async (): Promise<CoachPublicInfo> => {
    return api({
      route: `/coach/${coachId}/`,
    });
  };

  const { data, isLoading, isError } = useQuery<CoachPublicInfo, Error>(
    ['public-coach-info', coachId],
    fetchPublicInfo,
    { enabled: !!coachId, refetchOnWindowFocus: false }
  );

  return {
    isLoading,
    isError,
    data,
  };
};
